import { render } from "./HiAvatar.vue?vue&type=template&id=21dff84d&scoped=true"
import script from "./HiAvatar.vue?vue&type=script&lang=js"
export * from "./HiAvatar.vue?vue&type=script&lang=js"

import "./HiAvatar.vue?vue&type=style&index=0&id=21dff84d&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21dff84d"]])

export default __exports__